// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0de92562","453":"72ae699b","667":"ae1d0bb6","727":"d4e14015","977":"9aa57d15"}[chunkId] + ".chunk.js";
};